<!--&lt;!&ndash; @TODO output Author, BlogCategory, Description, Image, EntryDate &ndash;&gt;-->

<div class="default-max-width centered margin--bottom-l margin--top-l blog-page">
  <ng-container *ngIf="blogPost$ | async as post">
    <img class="header-img-blog" src="{{ post.image.url }}" alt="" />

    <div class="headline-second margin--top-l margin--bottom-l">{{ post.title }}</div>

    <p>{{ post.entryDate | translocoDate : { dateStyle: "full" } : "de-CH" }},</p>
    <p>
      von <strong>{{ post.author.name }}</strong>
    </p>

    <app-content class="blog-content" *ngIf="blogPost$ | async as post" [page]="post"></app-content>
  </ng-container>
</div>
